import { useEffect, useMemo } from "react";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import { buildProjectionRequestKey } from "@contexts/projects/projectionScope";
import ProjectionLoadState from "@components/dashboard/financialProjection/ProjectionLoadState";
import AccordionItem from "./AccordionItem";

const ServiceAccordion = ({ parent, parentLabel, filters, path = [], containerId }) => {
  const { activeProject: { _id, services = {} }, projectionLoads = {} } = useProjectContext();
  const { loadServices } = useProjectActions();
  const substepServices = useMemo(() => services[parent], [services, parent]);
  const serviceLoad = projectionLoads[buildProjectionRequestKey("services", parent)];

  useEffect(() => {
    if (_id && !substepServices && !serviceLoad) loadServices(parent);
  }, [_id, parent, substepServices, serviceLoad, loadServices]);

  return (
    <>
      <ProjectionLoadState
        level="services"
        parent={parent}
        parentLabel={parentLabel}
        isMissing={!substepServices}
        onRetry={() => loadServices(parent)}
        focusTargetId={containerId}
        showErrorCode
      />
      {substepServices?.map((item) => (
        <AccordionItem
          key={item.wbs_code_id}
          item={item}
          type="service"
          typeTitle="Serviço"
          filters={filters}
          path={path}
        />
      ))}
    </>
  );
};

export default ServiceAccordion;
